import { render, staticRenderFns } from "./DSCards.vue?vue&type=template&id=3425647f&"
import script from "./DSCards.vue?vue&type=script&lang=js&"
export * from "./DSCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports